/**
 * The LegalEntityService proto enforces `^[0-9]{9}$` on `Organization.fein`,
 * but `OrganizationIdentifier.organization_fein` has no validator. Without
 * normalization, a stored value of `123456789` won't match a user-supplied
 * `12-3456789` on lookup. Strip separators before any FEIN-typed call.
 */
export const normalizeFein = (fein: string): string =>
  fein.replace(/[\s-]/g, '');
